import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICampaign, IUser } from '@shared';
import Stripe from 'stripe';

@Injectable({
  providedIn: 'root'
})
export class SuccessService {
  constructor(private http: HttpClient) { }

  rootURL = '/api';

  getCheckoutSession(id: string): Observable<Stripe.Checkout.Session> {
    return this.http.get<Stripe.Checkout.Session>(`${this.rootURL}/stripe/checkout-session/${id}`, { responseType: 'json' });
  }

  addCampaign(campaign: ICampaign): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(`${this.rootURL}/campaigns`, campaign, { responseType: undefined });
  }

  sendEmail(): Observable<void> {
    return this.http.post<void>(`${this.rootURL}/mailing`, null);
  }
}
